import React from 'react';
import './App.css';

import { IndustrialHeader } from './components/IndustrialHeader';
import { HeroManual } from './components/HeroManual';
import { ServicesSection } from './components/ServicesSection';
import { AboutSection } from './components/AboutSection';
import { ContactSection } from './components/ContactSection';
import { IndustrialFooter } from './components/IndustrialFooter';

import { Toaster } from './components/ui/sonner';
import { LanguageProvider } from './contexts/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      {/* Root wrapper — HARD mobile safety */}
      <div className="App relative w-full min-h-screen overflow-x-hidden">

        {/* Noise Texture */}
        <div className="noise-overlay pointer-events-none" />

        {/* Grid Overlay */}
        <div className="grid-overlay pointer-events-none" />

        {/* Main Content */}
        <div className="relative z-10 w-full max-w-full overflow-x-hidden">
          <IndustrialHeader />

          <main className="w-full max-w-full overflow-x-hidden">
            <HeroManual />
            <ServicesSection />
            <AboutSection />
            <ContactSection />
          </main>

          <IndustrialFooter />
        </div>

        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;
